import React from 'react';
import {navigate} from '@reach/router';
import FrnModal from 'components/ComponentLibrary/FrnModal/FrnModal';
import OptinFormChallenge from './OptinFormChallenge';
import {useModal} from 'contexts/modal';

export default function OptinFormChallengeModal({
  navigateEntry = 'default',
  navigateUrl,
  disableNavigate = false,
  optinFormProps,
  className = undefined
}) {
  const modalProps = useModal();

  const [navigateOnClose, setNavigateOnClose] = React.useState(false);

  const onComplete = React.useCallback(() => {
    !disableNavigate && navigate(`${navigateUrl}${navigateEntry !== 'default' ? `?entry=${navigateEntry}` : ''}`);
    modalProps.toggle();
  }, []);

  const onStepComplete = React.useCallback((step) => step === 1 && setNavigateOnClose(true), []);

  const toggle = React.useCallback(() => {
    if (navigateOnClose && !disableNavigate)
      navigate(`${navigateUrl}${navigateEntry !== 'default' ? `?entry=${navigateEntry}` : ''}`);
    modalProps.toggle();
  }, [navigateOnClose]);

  return (
    <FrnModal className={className} isOpen={modalProps.isOpen} toggle={toggle} modalBodyClass="px-4 pt-0 pb-4">
      <OptinFormChallenge
        onComplete={onComplete}
        onStepComplete={onStepComplete}
        navigateEntry={navigateEntry}
        navigateUrl={navigateUrl}
        {...optinFormProps}
      />
    </FrnModal>
  );
}
